export const fromConferences = ({ conferences }) => conferences;
export const fromTranscripts = ({ transcripts }) => transcripts;

export const selectList = ({ list }) => list;
export const selectIsCloudSearchResults = ({ isCloudSearchResults }) =>
  isCloudSearchResults;
export const selectIsFetching = ({ isFetching }) => isFetching;
export const selectPagination = ({ currentPage, numberPerPage, totalPages }) => ({
  currentPage,
  numberPerPage,
  totalPages,
});
export const selectFilters = ({ from, to, title, analyst, order }) => ({
  from,
  to,
  title,
  analyst,
  order,
});



// WEBPACK FOOTER //
// ./redux/selectors/dashboard.js